import { useAppSelector } from 'application/providers/StoreProvider';
import { selectIsAuthorized } from 'application/store/slices/accountSlice/selectors';

export const useAccountIsAuthorized = () => {
  const isAuthorized = useAppSelector(selectIsAuthorized);

  return isAuthorized;
};
